module.exports = __webpack_public_path__ + "img/logo-super-tuti.f584adcf.png";